export default "__VITE_ASSET__6pwIkArj__"